import type { Claim, Entity } from "../domain";

export const ModelTable = ({ entities, claims }: { entities: Entity[]; claims: Claim[] }) => {
  const claimsByEntity = new Map(claims.map((claim) => [claim.entityId, claim]));
  const models = entities.filter((entity) => entity.kind === "model");
  return (
    <section className="section-block" id="models" aria-labelledby="models-heading">
      <div className="section-heading">
        <div>
          <h2 id="models-heading">Model comparison</h2>
          <p>A factual release snapshot. Performance comparisons require separate independent evidence.</p>
        </div>
        <a href="/now.json">Full data <span aria-hidden="true">→</span></a>
      </div>
      <div className="table-scroll" tabIndex={0} role="region" aria-label="Model release comparison table">
        <table>
          <thead>
            <tr>
              <th scope="col">Model</th>
              <th scope="col">Organization</th>
              <th scope="col">Release / announced</th>
              <th scope="col">Evidence</th>
              <th scope="col">Ledger status</th>
            </tr>
          </thead>
          <tbody>
            {models.map((entity) => {
              const claim = claimsByEntity.get(entity.id);
              return (
                <tr key={entity.id}>
                  <th scope="row">{entity.name}</th>
                  <td>{entity.organization}</td>
                  <td>{claim?.effectiveAt.slice(0, 10)}</td>
                  <td>{claim?.evidenceClass.replace("_", " ")}</td>
                  <td>{claim?.status}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </section>
  );
};

